/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconAlertFilled16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconAlertFilled16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.158 1.465a2.755 2.755 0 0 1 1.685 0c.582.188 1.01.625 1.4 1.155.385.526.806 1.253 1.331 2.157l2.22 3.826c.518.893.934 1.61 1.196 2.197.264.593.427 1.172.3 1.757-.121.55-.415 1.05-.841 1.426-.452.4-1.044.547-1.698.616-.648.068-1.486.068-2.53.068H5.78c-1.044 0-1.882 0-2.53-.068-.654-.069-1.246-.216-1.698-.616a2.665 2.665 0 0 1-.84-1.426c-.129-.585.035-1.164.299-1.757.261-.588.677-1.304 1.195-2.197l2.22-3.826c.526-.904.947-1.63 1.333-2.157.388-.53.817-.967 1.399-1.155Zm.176 7.869-.167-4.667h1.667l-.167 4.667H7.334Zm1.833 2.663a1.167 1.167 0 1 1-2.333 0 1.167 1.167 0 0 1 2.333 0Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconAlertFilled24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconAlertFilled24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.737 2.198a4.132 4.132 0 0 1 2.526 0c.874.28 1.517.937 2.1 1.732.578.79 1.21 1.879 1.998 3.236l3.33 5.739c.777 1.338 1.4 2.413 1.793 3.295.396.89.641 1.758.45 2.636a3.997 3.997 0 0 1-1.261 2.138c-.679.6-1.566.821-2.547.924-.972.102-2.23.102-3.795.102H8.669c-1.565 0-2.823 0-3.795-.102-.98-.103-1.868-.324-2.547-.924a3.997 3.997 0 0 1-1.26-2.138c-.192-.878.053-1.747.449-2.636.392-.882 1.016-1.957 1.793-3.295l3.33-5.74C7.427 5.81 8.06 4.72 8.637 3.93c.584-.795 1.226-1.451 2.1-1.732ZM11 14l-.25-7h2.5L13 14h-2Zm2.75 3.995a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconAlertFilled = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconAlertFilled(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '16':
            return <IconAlertFilled16 {...iconProps} />;
        case '24':
            return <IconAlertFilled24 {...iconProps} />;
        default:
            return <IconAlertFilled24 {...iconProps} />;
    }
});
